import Vue from 'vue';
import storePwa from '@/modules/pwa/Store';
import routerPwa from '@/modules/pwa/Router/router';
import pwaApp from '@/modules/pwa/App.vue';

storePwa.state.newDashboardColorsEnabled = document.querySelector('#pwa')
  .getAttribute('data-feature-new-dashboard-colors');

new Vue({
  render: (h) => h(pwaApp),
  store: storePwa,
  router: routerPwa,
}).$mount('#pwa');
